import PropTypes from 'prop-types';

const assignment = PropTypes.shape({
  assignGuid: PropTypes.number.isRequired,
  primaryLabel: PropTypes.string.isRequired,
  secondaryLabel: PropTypes.string,
  description: PropTypes.string,
  assignedCopiesCount: PropTypes.number.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  visualStartDate: PropTypes.string.isRequired,
  visualEndDate: PropTypes.string.isRequired,
  visitStarted: PropTypes.string,
  visitEnded: PropTypes.string,
  totalCopiesCount: PropTypes.number.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  isOverlapping: PropTypes.bool.isRequired,
  assignmentType: PropTypes.string.isRequired,
  postcode: PropTypes.string,
  travelTime: PropTypes.number,
});

export default assignment;
